import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Spin } from "antd";
import { useLocation } from "react-router-dom";
import QuestionModule from "../../../components/UI/Questionaire/CRR-Survey/QuestionModule";
import {
  clearCRRSurvey,
  fetchQuestions,
  getAuditTrail,
  getMilData,
  getPracticesData,
  submitAnswer,
} from "../../../slices/Employee/survey-CRR.slice";
import {
  getGoalsData,
  getGoalsDataForColouring,
  enrichGoalQuestionOrder,
} from "../../../slices/Employee/goals.slice";
import { getEmployeeDashboardData } from "../../../slices/Employee/employeeDashboard.slice";
import {
  checkIsAdmin,
  getLocalStorage,
  scrollToElement,
} from "../../../helpers/utils";
import { DrawerComponent } from "../../../components/UI/Drawer/DrawerComponent";
import AuditTrail from "../AuditTrail";
import SurveyHeader from "../SurveyHeader";
import SurveyFooter from "./SurveyFooter";
import "../SurveyStyles.scss";
import { clearCSFSurvey } from "../../../slices/Admin/survey-CSF.slice";

export default function CRRSurvey({ isAdminView, selectedSurvey }) {
  const {
    questionData,
    goalInfo,
    selectedGoal,
    selectedDomain,
    selectedQuestion,
    auditData,
    auditLoading,
  } = useSelector((state) => state.CRRsurvey);
  const selectedSurveyId = selectedSurvey?.id;

  const dispatch = useDispatch();
  const history = useHistory();
  const [lastAnswer, setLastAnswer] = useState("");
  const [questionTitle, setQuestionTitle] = useState("");
  const [IsSubmitClicked, setIsSubmitClicked] = useState(false);
  const isAdminLogin = checkIsAdmin();
  const [isAuditTrailOpen, setIsAuditTrailOpen] = useState(false);
  const location = useLocation();
  const { domains } = useSelector(
    (state) => state.employeeDashboard.employeeDashboardData || {}
  );
  const selectedSurveyStatus = getLocalStorage("SELECTED-SURVEY-STATUS"); // for employee dashboard

  const openAuditTrail = (value) => {
    setIsAuditTrailOpen(value);
  };

  useEffect(() => {
    if (selectedGoal?.id) {
      const { is_goal, mil_no, order } = selectedGoal;
      setQuestionTitle(is_goal ? `Goal ${order} ` : `MIL ${mil_no} `);
    }
  }, [selectedGoal]);

  useEffect(() => {
    if (selectedGoal?.id) {
      const surveyId = selectedSurveyId || "";
      if (isAdminLogin && !selectedSurveyId) {
        history.push("/admin-survey-list");
      } else {
        dispatch(fetchQuestions(selectedGoal?.id, surveyId));
      }
    }
  }, [selectedGoal, selectedSurveyId, isAdminLogin, dispatch, history]);

  useEffect(() => {
    updateGraphData();
  }, [selectedDomain]);

  useEffect(() => {
    dispatch(clearCSFSurvey());
  }, []);

  useEffect(() => {
    if (selectedQuestion?.id) {
      const element = document.getElementById(selectedQuestion?.id);
      scrollToElement(element);
    }
  }, [selectedQuestion]);

  useEffect(() => {
    if (selectedGoal?.id && questionData?.questions?.length) {
      dispatch(
        enrichGoalQuestionOrder({
          goalId: selectedGoal.id,
          questions: questionData.questions,
        })
      );
    }
  }, [selectedGoal?.id, questionData?.questions, dispatch]);

  const updateGraphData = () => {
    if (selectedDomain?.id) {
      dispatch(getMilData(selectedDomain?.id, selectedSurveyId));
      dispatch(getPracticesData(selectedDomain?.id, selectedSurveyId));
    }
  };

  const updateAuditData = (qnId, categoryId) => {
    dispatch(getAuditTrail(selectedSurveyId, qnId, categoryId));
  };

  const isDomainRestricted = () => {
    if (location?.state?.id === selectedDomain?.id) {
      return location?.state?.surveyEditStatusFromDasboard;
    } else return selectedDomain?.write_access;
  };

  const surveyHeaderProps = {
    description: selectedDomain?.description,
    title: selectedDomain?.domain,
    selectedSurvey: selectedSurveyId,
  };
  const surveyFooterProps = {
    questionData,
    questionTitle,
    lastAnswer,
    IsSubmitClicked,
    goalInfo,
    domains,
    setIsSubmitClicked,
  };

  const handleAnswerSubmit = (answer, questn) => {
    dispatch(
      submitAnswer(questn.id, answer, () => {
        updateGraphData();
        dispatch(
          getGoalsDataForColouring(
            selectedDomain?.id,
            selectedSurveyId,
            selectedGoal?.id
          )
        );
        setIsSubmitClicked(true);
        setLastAnswer(answer);
      })
    );
  };

  return (
    <div className="list-container fixed">
      <div
        className={`${
          selectedSurvey ? "selected-survey-wrapper" : "survey-wrapper"
        }`}
      >
        <SurveyHeader {...surveyHeaderProps} />
        <div
          className="goals-wrapper"
          style={{
            maxHeight: selectedSurveyId
              ? "calc(100vh - 329px)"
              : "calc(100vh - 379px)",
          }}
        >
          {questionTitle && (
            <div className="goal-description">
              {questionTitle}:
              <br /> {selectedGoal?.name}
            </div>
          )}
          <>
            {questionData?.questions?.length > 0 ? (
              <div className="question-container">
                {[...(questionData?.questions || [])]
                  .sort((a, b) => (a?.order ?? 0) - (b?.order ?? 0))
                  .map((questn) => (
                    <QuestionModule
                      qnObj={questn}
                      key={questn.id}
                      setAnswer={(answer) => handleAnswerSubmit(answer, questn)}
                      isAdminView={
                        !isDomainRestricted() ||
                        isAdminView ||
                        (selectedSurveyStatus &&
                          selectedSurveyStatus.status !== "In Progress")
                      }
                      openAuditTrail={openAuditTrail}
                      updateAuditData={updateAuditData}
                    />
                  ))}

                <SurveyFooter {...surveyFooterProps} />
              </div>
            ) : (
              <div className="question-loader">
                <Spin />
              </div>
            )}
          </>
          <DrawerComponent
            content={
              <AuditTrail auditData={auditData} loading={auditLoading} />
            }
            drawerVisible={isAuditTrailOpen}
            onClose={() => openAuditTrail(false)}
          />
        </div>
      </div>
    </div>
  );
}
